import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withLocalize } from 'react-localize-redux';
import { isEmpty } from 'lodash';
import { Grid } from 'semantic-ui-react';
import EventTile from '../eventTile';

const PopularEventCards = props => {
  const { user, popularEvents } = props;
  if (isEmpty(popularEvents)) {
    return (
      <div>There are no popular events</div>
    );
  }

  return (
    popularEvents.map((event, idx) => {
      if (popularEvents.length > 2 && idx === 3) {
        return (
          <Grid.Column
            stretched textAlign='center'
            only='computer' widescreen={4} largeScreen={4}
            computer={5}
            key={`event-${event.slug}`}
          >
            <EventTile
              event={event}
              user={user}
            />
          </Grid.Column>
        );
      }
      if (popularEvents.length > 1 && idx === 2) {
        return (
          <Grid.Column
            stretched textAlign='center'
            only='large screen' widescreen={4} largeScreen={4}
            key={`event-${event.slug}`}
          >
            <EventTile
              event={event}
              user={user}
            />
          </Grid.Column>
        );
      }
      return (
        <Grid.Column
          stretched textAlign='center'
          widescreen={4} largeScreen={4} computer={5}
          mobile={16} tablet={8}
          key={`event-${event.slug}`}
        >
          <EventTile
            event={event}
            user={user}
          />
        </Grid.Column>
      );
    })
  );
};


export default compose(
  withLocalize,
  connect(({ user }) => ({ user }))
)(PopularEventCards);



// WEBPACK FOOTER //
// ./src/components/events/components/popularEventCards.js